/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '@angular/router/src/directives/router_outlet';
import * as import1 from '@angular/core/src/linker/view';
export class Wrapper_RouterOutlet {
  /*private*/ _eventHandler:Function;
  context:import0.RouterOutlet;
  /*private*/ _changed:boolean;
  subscription0:any;
  subscription1:any;
  constructor(p0:any,p1:any,p2:any,p3:any) {
    this._changed = false;
    this.context = new import0.RouterOutlet(p0,p1,p2,p3);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    this.context.ngOnDestroy();
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.activateEvents.subscribe(_eventHandler.bind(view,'activate'))); }
    if (emit1) { (this.subscription1 = this.context.deactivateEvents.subscribe(_eventHandler.bind(view,'deactivate'))); }
  }
}


// WEBPACK FOOTER //
// ./src/$$_gendir/~/@angular/router/src/directives/router_outlet.ngfactory.ts